import { logout, logoutSuccess, LOGOUT_SUCCESS } from './login';
import Auth from './_components/Auth';

const getToken = () => localStorage.getItem('jwtToken');

export { Auth, logout, logoutSuccess, LOGOUT_SUCCESS, getToken };
